import { IconLoader } from '@ui/src';
import Card from '../../card/card';
import DocumentRowHeader from './document-row-header';
import { CustomerDocument } from '../../../../hoc/common/documents/types';
import { DocumentsTypes } from '../types';
import DocumentsItems from './documents-items';

import cn from '../styles.module.css';

const DocumentsContent = ({
  selectedCategory,
  onGroupSelect,
  onGroupByIdSelect,
  currentCategoryDocuments,
  status,
  allDocumentsSelected,
  selectedDocumentsCategoryId,
  allDocumentsTotal,
  documentsByCategoryTotal,
  selectedStatuses,
  setSelectedStatuses,
  sort,
  onChangeSort,
  sortProp,
  onSelect,
  customerId,
  customerType,
  setRenamePopupVisible,
  setSelectedDocumentToRename,
  updateExpiredDocumentsState,
  isLoading,
  documentsIsFetching,
}: DocumentsTypes) => (
  <div className={cn.documents}>
    <Card transparent>
      <DocumentRowHeader
        type={selectedCategory?.id as string}
        onGroupSelect={onGroupSelect}
        onGroupByIdSelect={onGroupByIdSelect}
        documents={currentCategoryDocuments as CustomerDocument[]}
        status={status}
        depricated={Boolean(
          currentCategoryDocuments
            ?.filter(
              (document) =>
                document?.documentCategoryId === selectedCategory?.id ||
                document?.category === selectedCategory?.category,
            )
            ?.find((document) => document.category),
        )}
        documentsSelected={
          selectedCategory?.id === 'all'
            ? allDocumentsSelected
            : selectedDocumentsCategoryId
        }
        total={
          selectedCategory?.id === 'all'
            ? allDocumentsTotal
            : documentsByCategoryTotal
        }
        selectedStatuses={selectedStatuses}
        setSelectedStatuses={setSelectedStatuses}
        sort={sort}
        onChangeSort={onChangeSort}
        sortProp={sortProp}
      />
      <DocumentsItems
        documents={currentCategoryDocuments as CustomerDocument[]}
        onSelect={onSelect}
        type={selectedCategory?.id as string}
        customerId={customerId}
        customerType={customerType}
        setRenamePopupVisible={setRenamePopupVisible}
        setSelectedDocumentToRename={setSelectedDocumentToRename}
        status={status}
        updateExpiredDocumentsState={updateExpiredDocumentsState}
      />
    </Card>
    {isLoading && (
      <div
        className={`${cn.documentsLoader} ${
          documentsIsFetching ? cn.documentsIsFetching : ''
        }`}
      >
        <IconLoader />
      </div>
    )}
    {!currentCategoryDocuments?.length && !isLoading && (
      <div className={cn.emptyDocuments}>No documents yet</div>
    )}
  </div>
);

export default DocumentsContent;
